import {
  GET_TEMPLATES,
  GET_TEMPLATES_ERROR,
  TEMPLATES_LOADING,
  GET_TEMPLATE_STATS,
  UPDATE_TEMPLATE,
  DELETE_TEMPLATE,
} from "../actions/types";

const initialState = {
  templates: [],
  // { template, printer, opened, generated, scanned } per template and kiosk
  stats: [],
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_TEMPLATES:
      return {
        ...state,
        loading: false,
        templates: payload,
      };
    case GET_TEMPLATES_ERROR:
      return {
        ...state,
        loading: false,
      };
    case TEMPLATES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_TEMPLATE_STATS:
      return {
        ...state,
        stats: payload,
      };
    case UPDATE_TEMPLATE: {
      // The list is loaded without bodies
      const { body, ...template } = payload;
      const known = state.templates.some((item) => item._id === template._id);
      return {
        ...state,
        templates: known
          ? state.templates.map((item) =>
              item._id === template._id ? template : item
            )
          : [...state.templates, template],
      };
    }
    case DELETE_TEMPLATE:
      return {
        ...state,
        templates: state.templates.filter((item) => item._id !== payload),
      };
    default:
      return state;
  }
}
